import { render, staticRenderFns } from "./contact-list.vue?vue&type=template&id=67777343&scoped=true&"
import script from "./contact-list.vue?vue&type=script&lang=js&"
export * from "./contact-list.vue?vue&type=script&lang=js&"
import style0 from "./contact-list.vue?vue&type=style&index=0&id=67777343&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67777343",
  null
  
)

export default component.exports